import SparkMD5 from 'spark-md5';

export function countMd5(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const spark = new SparkMD5.ArrayBuffer();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      if (e.target?.result instanceof ArrayBuffer) {
        spark.append(e.target.result);
        resolve(spark.end());
      } else {
        reject('');
      }
    };
  });
}

/**
 * 格式化文件大小，自动选择合适的单位
 * @param {number} bytes - 文件大小（字节）
 * @param {number} [decimals=2] - 保留的小数位数，默认为2
 * @returns {string} 格式化后的文件大小字符串
 */
export function formatFileSize(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // 处理小数位数
  let dm = decimals;
  if (bytes < 1) dm = 0;

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
